/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetAddressbyPostalcodeData,
  GetAddressbyPostalcodeDataFromJSON,
  GetAddressbyPostalcodeDataFromJSONTyped,
  GetAddressbyPostalcodeDataToJSON
} from './GetAddressbyPostalcodeData'

/**
 *
 * @export
 * @interface GetAddressbyPostalcode
 */
export interface GetAddressbyPostalcode {
  /**
   *
   * @type {number}
   * @memberof GetAddressbyPostalcode
   */
  status?: number
  /**
   *
   * @type {GetAddressbyPostalcodeData}
   * @memberof GetAddressbyPostalcode
   */
  data?: GetAddressbyPostalcodeData
}

export function GetAddressbyPostalcodeFromJSON(json: any): GetAddressbyPostalcode {
  return GetAddressbyPostalcodeFromJSONTyped(json, false)
}

export function GetAddressbyPostalcodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAddressbyPostalcode {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetAddressbyPostalcodeDataFromJSON(json['data'])
  }
}

export function GetAddressbyPostalcodeToJSON(value?: GetAddressbyPostalcode | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetAddressbyPostalcodeDataToJSON(value.data)
  }
}
